import { Column } from "@/components/Datatable/types";
import { RegistrationsReportItem } from "../../api/fetchRegistrationsReport/types";

export function registrationsReportColumns(): Column<RegistrationsReportItem>[] {
  return [
    {
      header: "Company Name",
      accessorKey: "companyName",
      enableSorting: true,
      cell: ({ row }) => row.original.companyName,
    },
    {
      header: "Intacct ID",
      accessorKey: "intacctId",
      cell: ({ row }) => row.original.intacctId ?? "",
    },
    {
      header: "Full Name",
      accessorKey: "fullName",
      enableSorting: true,
      cell: ({ row }) => row.original.fullName,
    },
    {
      header: "Event",
      accessorKey: "eventName",
      enableSorting: true,
      cell: ({ row }) => row.original.eventName,
    },
    {
      header: "Session",
      accessorKey: "sessionName",
      enableSorting: true,
      cell: ({ row }) => row.original.sessionName,
    },
    {
      header: "Session Dates",
      accessorKey: "sessionStartDate",
      enableSorting: true,
      cell: ({ row }) => {
        const { sessionStartDate, sessionEndDate } = row.original;
        if (!sessionStartDate) return "";
        return sessionEndDate
          ? `${sessionStartDate} - ${sessionEndDate}`
          : sessionStartDate;
      },
    },
    {
      header: "Location",
      accessorKey: "location",
      cell: ({ row }) => row.original.location,
    },
    {
      header: "Enrolled On",
      accessorKey: "enrolledOn",
      enableSorting: true,
      cell: ({ row }) => row.original.enrolledOn ?? "",
    },
    {
      header: "Status",
      accessorKey: "status",
      cell: ({ row }) => row.original.status,
    },
    {
      header: "Retail Price",
      accessorKey: "retailPrice",
      enableSorting: true,
      cell: ({ row }) =>
        row.original.retailPrice ? `$${row.original.retailPrice}` : "",
    },
    {
      header: "Net Price",
      accessorKey: "netPrice",
      enableSorting: true,
      cell: ({ row }) =>
        row.original.netPrice ? `$${row.original.netPrice}` : "",
    },
    {
      header: "Description",
      accessorKey: "description",
      cell: ({ row }) => row.original.description ?? "",
    },
  ];
}
